<script>
    import {
        Card,
        Col,
        Container,
        Row,
        Spinner
    } from "sveltestrap";
    import { _ } from "svelte-i18n"
</script>

<Container>
    <Row>
        <Col lg="2"></Col>
        <Col lg="8">
            <Card body class="text-center">
                <div class="d-flex justify-content-center">
                    <Spinner color="warning" size="lg" type="border" style="width: 5rem; height: 5rem;" />
                </div>
                <h2>{$_("components.Loading.loading")}...</h2>
            </Card>
        </Col>
        <Col lg="2"></Col>
    </Row>
</Container>